module.exports = __webpack_public_path__ + "static/img/timo.b1253a5a.png";